/**
 * 请求权限相关
 */
import { getToken, getSessionId } from '@/utils/auth'
import { getNowFormatDate } from '@/utils/index'
// import { sha256 } from 'js-sha256'

const ignorePath = ['Common/api/v2/login']

/**
 * 封装请求的参数
 * @param {Object} data 请求的参数
 */
export function handleRequestData (data, url, baseURL) {
  if (!checkRequestUrl(url, baseURL)) {
    if (!data) {
      data = {}
    }
    data = JSON.stringify(data)
    const sessionId = getSessionId()
    const requestTime = getNowFormatDate().UTCDate.format1
    const signString = data + sessionId + requestTime
    // hashs算法
    var Hashes = require('jshashes')
    let SHA256 = new Hashes.SHA256()
    const authorization = SHA256.hex_hmac(getToken(), signString)
    return {
      Data: data,
      SessionId: sessionId,
      RequestTime: requestTime,
      Authorization: authorization,
      // TODO: 多语言功能，目前默认显示中文CN
      Lang: 'cn'
    }
  } else {
    return data
  }
}

function checkRequestUrl (url, baseURL) {
  const path = url.replace(baseURL, '')
  if (ignorePath.indexOf(path) !== -1) {
    return true
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/request-operate.js